import { select } from '@neptune/cx/utils';
import { registerFragment } from '@neptune/cx/registry';
import Splide from '@splidejs/splide';
import './styles.scss';

registerFragment('chroa-video-slider', (fragmentEl) => {
    // 1. Only run this optimization in View Mode
    if (!document.body.classList.contains('has-edit-mode-menu')) {
        const sliderEl = select<HTMLDivElement>(fragmentEl, '.splide');

        if (sliderEl) {
            const slidesPerView = parseInt(sliderEl.getAttribute('data-slides-per-view') || '3', 10);
            const showArrows = sliderEl.getAttribute('data-show-arrows') !== 'false';
            const showDots = sliderEl.getAttribute('data-show-dots') !== 'false';

            const splideOptions: any = {
                type: 'slide',
                perPage: slidesPerView,
                perMove: 1,
                // focus: 'center',
                arrows: showArrows,
                pagination: showDots,
                gap: '24px',
                drag: true,
                keyboard: 'focused',
                breakpoints: {
                    1023: { perPage: Math.min(slidesPerView, 2) },
                    599: { perPage: 1 }
                }
            };

            const splide = new Splide(sliderEl, splideOptions);

            splide.mount();
        }
    }
});
